var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'news' || _vm.type === 'api' || _vm.type === 'document')?_c('NewsPage'):_vm._e(),(
      _vm.type === 'twitter' ||
      _vm.type === 'weibo' ||
      _vm.type === 'facebook' ||
      _vm.type === 'vk' ||
      _vm.type === 'tg' ||
      _vm.type === 'ins'
    )?_c('WeMedia'):_vm._e(),(_vm.type === 'toutiao')?_c('Toutiao'):_vm._e(),(_vm.type === 'wechat')?_c('Wechat'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }